// Lexer for glycans - splits glycans into tokens
// Version 0.1
// 26/05/2024

import resmap from '../data/resdict.json';

//Splits CASPER string into token list.
export function lexChain(stringInput, startPos = 0)
{
    var tokens = [];
    var currentPos = startPos;

    let isRepeatingUnit = checkRepeatingUnit(stringInput);

    if (isRepeatingUnit)
    {
        let [token, content] = isRepeatingUnit;
        tokens.push(token);
        stringInput = content;
    }

    while (currentPos < stringInput.length)
    {
        let [token, pos] = lexToken(stringInput, currentPos);
        tokens.push(token);
        currentPos = pos;
    }
    
    return tokens;
}

//Checks if a repeating unit token is present.
export function checkRepeatingUnit(stringInput)
{
    let token = {type:'rep'};
    let nums = stringInput.match(/^->(\d+)\)(.*)\((\d+)->$/);
    if (nums)
    {
        token.first_number = nums[1];
        token.second_number = nums[3];
        return [token, nums[2]];
    }
    return false;
}

//Identifies type of token.
export function lexToken(stringInput, startPos = 0) 
{
    var token, outPos;
    //need to add try-catch here to handle lexing errors.
    let currentChar = stringInput.charAt(startPos);

    //residue
    if (/[0-9A-Za-z]/.test(currentChar))
    {   
        [token, outPos] = readResidue(stringInput, startPos);
    }
    //linkage
    else if (/\(/.test(currentChar)) 
    {
        [token, outPos] = readLinkage(stringInput, startPos);
    }
    //branch or comment
    else if (/\[/.test(currentChar))
    {
        [token, outPos] = readBranchComment(stringInput, startPos);
    }
    //acetylation or similar
    else if (/\{/.test(currentChar))
    {
        [token, outPos] = readSubstitution(stringInput, startPos);
    }

    return [token, outPos];
}

//Read and extract information from residue token.
export function readResidue(stringInput, tokenStartPos)
{
    let currentPos = tokenStartPos;
    let text = "";
    let token = {type:'res'};

    //check first character anomeric [a or b]
    if (!/[ab]/.test(stringInput.charAt(currentPos)))
    {
        //in some cases this can be missing
    } else {
        stringInput.charAt(currentPos) === 'a' ? token.ano = 'a' : token.ano = 'b';
        currentPos += 1;
    }

    //check next character absolute [D or L]
    if (!/[DL]/.test(stringInput.charAt(currentPos)))
    {
        token.abs = 'D';
        //Some residues like Leg have absolute configuration implied
    } else {
        if (/[L]/.test(stringInput.charAt(currentPos)) && /[e]/.test(stringInput.charAt(currentPos+1))) 
            {token.abs = 'D'; } //special case for "Leg"
        else if (/[D]/.test(stringInput.charAt(currentPos)) && /[h]/.test(stringInput.charAt(currentPos+1))) 
            {token.abs = 'D'; } //special case for "Dha"
        else { 
        stringInput.charAt(currentPos) === 'D' ? token.abs = 'D' : token.abs = 'L';
        currentPos += 1;
        }
    }

    while (currentPos < stringInput.length)
    {
        let currentChar = stringInput.charAt(currentPos);

        //if we get to the end of a residue
        if (!/[A-Za-z0-9\-\s]/.test(currentChar)) {
            break;
        } else {
            text += currentChar;
            currentPos += 1;
        }
    }

 //   if(text[3] === 'f' || text[3] === 'p')
 if( text[3] === 'f' || text[3] === 'p')
    {
        if(text[3] === 'f'){
            token.fur = 'f';
        } else {
            token.fur = 'p';
            text = text.slice(0,3) + text.slice(4,text.length);
        }
    } else {
        token.fur = 'p';
    }

    let [mapping, additional] = sliceContent(text);
    token.text = mapping;
    token.additional = additional;
    token.startPos = tokenStartPos;
    token.tokenLength = currentPos - tokenStartPos;
    return [token, currentPos];
}

//Slices text from a residue token.
export function sliceContent(text)
{
    let mapping,additional,front;
    let removed = text.length;
    while(removed > 0)
    {
        front = text.substring(0, removed);
        if(front in resmap){
            mapping = front;
            additional = text.substring(removed, text.length);
            break;
        }
        removed--;
    }
    return [mapping, additional];
}

//Read linkage token.
export function readLinkage(stringInput, tokenStartPos)
{
    let currentPos = tokenStartPos;
    let text = "";
    let token = {type:'lnk'};

    //read text input
    while (currentPos < stringInput.length)
    {
        let currentChar = stringInput.charAt(currentPos);
        if (/\)/.test(currentChar)) {
            text += ')'; //account for end of token
            currentPos += 1; //go to the start of the next token
            break;
        } else {
            text += currentChar;
            currentPos += 1;
        }
    }

   /* //check if it matches linkage structure
    if (!/\((\d+)->(\d+)\)/.test(text))
    {
        //throw some error here
    } else {
        let numbers = text.match(/\d+/g);
        token.from = numbers[0];
        token.to = numbers[1];
    }*/

//check if it matches linkage structure
    if (/\((\d+)->(\d+)\)/.test(text))
    {
       let numbers = text.match(/\d+/g);
        token.from = numbers[0];
        token.to = numbers[1];
    } else if (/\((\d+)->\P->(\d+)\)/.test(text))
    {
        let numbers = text.match(/\d+/g);
        token.from = 'P';
        token.to = numbers[0]+'-P-'+numbers[1];
    } else if (/\((\d+)->\N->(\d+)\)/.test(text))
    {
        let numbers = text.match(/\d+/g);
        token.from = 'N';
        token.to = numbers[0]+'-N-'+numbers[1];
    }
    else {
         //throw some error here
    }
    
    token.startPos = tokenStartPos;
    token.tokenLength = currentPos - tokenStartPos;
    return [token, currentPos];
}

//Read branch/comment token.
export function readBranchComment(stringInput, tokenStartPos)
{
    let currentPos = tokenStartPos + 1; //skip over first left bracket
    let text = "["; //keep left bracket for pattern matching later
    let token = {type:null};

    let leftBrackets = 1;
    let rightBrackets = 0;

    //read text input
    while (currentPos < stringInput.length && leftBrackets !== rightBrackets)
    {
        let currentChar = stringInput.charAt(currentPos);
        if (/\[/.test(currentChar)) { //encounter a nested chain
            leftBrackets += 1;
        } else if (/\]/.test(currentChar)) {
            rightBrackets += 1;
        }
        text += currentChar;
        currentPos += 1;
    }
/*  else if (/\((\d+)->\P->(\d+)\)/.test(text))
    {
        let numbers = text.match(/\d+/g);
        token.from = 'P';
        token.to = numbers[0]+'-P-'+numbers[1];
    }*/

    //check if it matches branch structure
    if (/^\[.*\(\d+->\d+\)\]$/.test(text))
    {
        token.type = 'brc';
        token.content = readBranch(text);
    } 
    else if (/\((\d+)->\P->(\d+)\)/.test(text)) //phosphate pattern
    {
        token.type = 'brc';
        token.content = readBranch(text);
    }
    else if (/\((\d+)->\N->(\d+)\)/.test(text)) //phosphate pattern
    {
        token.type = 'brc';
        token.content = readBranch(text);
    }
    else {
        token.type = 'com';
        token.comment = text.substring(1, text.length - 1);
    }

    token.startPos = tokenStartPos;
    token.tokenLength = currentPos - tokenStartPos;
    return [token, currentPos];
}

//read and extract information from branch token.
export function readBranch(stringInput)
{
    var tokens = [];
    var currentPos = 0;

    var token, outPos;

    let text = stringInput.substring(1, stringInput.length-1);

    while (currentPos < text.length)
    {
        [token, outPos] = lexToken(text, currentPos);
        tokens.push(token);
        currentPos = outPos;
    }

    return tokens;
}

//Read branch/comment token.
export function readSubstitution(stringInput, tokenStartPos)
{
    let currentPos = tokenStartPos + 1; //skip over first left bracket
    let text = "{"; //keep left bracket for pattern matching later
    let token = {type:null};

    let leftBrackets = 1;
    let rightBrackets = 0;

    //read text input
    while (currentPos < stringInput.length && leftBrackets !== rightBrackets)
    {
        let currentChar = stringInput.charAt(currentPos);
        if (/\{/.test(currentChar)) { //encounter a nested chain
            leftBrackets += 1;
        } else if (/\}/.test(currentChar)) {
            rightBrackets += 1;
        }
        text += currentChar;
        currentPos += 1;
    }

    
    token.type = 'sub';
    token.comment = text.substring(1, text.length - 1);
    

    token.startPos = tokenStartPos;
    token.tokenLength = currentPos - tokenStartPos;
    return [token, currentPos];
}

export default lexChain;